import React from 'react';
import PropTypes from 'prop-types';
import IdentityContext from '../../contexts/identity-context';
import LanguageContext from '../../contexts/language-context';
import NavigationContext from '../../contexts/navigation-context';
import ActiveApplicationContext from '../../contexts/active-application-context';
import ApplicationModulesContext from '../../contexts/application-modules-context.js';
import HelpProvider from '../help-provider';
import authProvider from '../../auth/auth0-provider';

export default function VhtApplicationContext(props) {
  const {applications, navigation, children} = props;
  const [navigationOpen, setNavigationOpen] = React.useState(true);
  const [language, setLanguage] = React.useState('');
  const [identityContext, setIdentityContext] = React.useState(authProvider.getContext());
  const [activeApplication, setActiveApplication] = React.useState({});
  const languageContextValue = React.useMemo(() => ({language, setLanguage}), [language]);
  const navigationContextValue = React.useMemo(
    () => ({
      open: navigationOpen,
      setOpen: setNavigationOpen,
      applications: navigation,
    }),
    [navigationOpen, navigation],
  );
  const activeApplicationContextValue = React.useMemo(
    () => ({
      application: activeApplication,
      setActiveApplication,
    }),
    [activeApplication],
  );
  React.useEffect(() => {
    authProvider.setUpdateHandler(setIdentityContext);
  }, []);

  return (
    <ApplicationModulesContext.Provider value={applications}>
      <IdentityContext.Provider value={identityContext}>
        <LanguageContext.Provider value={languageContextValue}>
          <ActiveApplicationContext.Provider value={activeApplicationContextValue}>
            <NavigationContext.Provider value={navigationContextValue}>
              <HelpProvider>{children}</HelpProvider>
            </NavigationContext.Provider>
          </ActiveApplicationContext.Provider>
        </LanguageContext.Provider>
      </IdentityContext.Provider>
    </ApplicationModulesContext.Provider>
  );
}

VhtApplicationContext.propTypes = {
  applications: PropTypes.array,
  navigation: PropTypes.array,
  children: PropTypes.node,
};
